import { render, staticRenderFns } from "./vina-von-sibenthal.vue?vue&type=template&id=0be6b69e&scoped=true"
import script from "./vina-von-sibenthal.vue?vue&type=script&lang=js"
export * from "./vina-von-sibenthal.vue?vue&type=script&lang=js"
import style0 from "./vina-von-sibenthal.vue?vue&type=style&index=0&id=0be6b69e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be6b69e",
  null
  
)

export default component.exports